<template>
  <el-dialog
    title="寄件实名信息（不可使用业务员信息实名）"
    :visible.sync="dialogVisible"
    width="470px"
    class="my-ruleForm"
  >
    <el-form
      :model="formData"
      :rules="rules"
      ref="ruleForm"
      size="small"
      label-width="100px"
    >
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="formData.name"
          placeholder="请输入真实姓名"
          autocomplete="off"
          maxlength="15"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="证件" prop="number">
        <el-input
          v-model.trim="formData.number"
          placeholder="请输入证件号"
          maxlength="20"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="证件类型" prop="card_type">
        <el-select v-model="formData.card_type" placeholder="请选择证件类型">
          <el-option
            v-for="item in card_type_list"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        </el-form-item>
      <div class="checkBox">
         <el-checkbox v-model="checked"></el-checkbox>
         <span>我同意韵商宝使用我所提交的信息用于快递寄件实名</span>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取消</el-button>
      <el-button type="primary" @click="save" size="small">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import home from "@/api/home";

export default {
  name: "realName",
  data() {
    return {
      dialogVisible: true,
      formData: {
        name: "",
        number: "",
        card_type:"01"
      },
      card_type_list:[
        {label:"大陆居民身份证/临时居民身份证",value:'01'},
        {label:"外国人永久居留身份证",value:'02'},
        {label:"户口薄",value:'03'},
        {label:"中国人民解放军军人身份证",value:'04'},
        {label:"中国人民武装警察身份证",value:'05'},
        {label:"港澳居民来往内地通行证",value:'06'},
        {label:"台湾居民来往大陆通行证",value:'07'},
        {label:"外国公民护照",value:'08'},
        {label:"中国公民护照",value:'09'},
        {label:"港澳台身份证",value:'10'},
        {label:"港澳台居民居住证",value:'11'}
      ],
      checked:false,
      rules: {
        name: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
        number: [
          {
            required: true,
            message: "请输入证件号",
            trigger: "blur",
          },
        ],
        card_type: [{ required: true, message: '请输入选择证件类型', trigger: 'blur' }],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    close() {
      this.dialogVisible = false;
      // localStorage.setItem("hasRealName", "");
    },
    save() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          // 实名
          if(!this.checked){
            this.$message.warning('请勾选同意信息授权')
            return
          }
          const number =  this.formData.number.trim()
          const card_type = this.formData.card_type
          if(number.length != 18 && (['04','05','07'].includes(card_type))){
            this.$message.warning('证件位数错误')
            return
          }
          if(number.length != 11 && card_type == '06'){
            this.$message.warning('证件位数错误')
            return
          }
          const regex = /^[A-Za-z]\d{8}$/;
          if(card_type == '09' && !regex.test(number)){
            this.$message.warning('证件格式错误')
            return
          }
          if(card_type == '10' && number.length < 8){
            this.$message.warning('证件位数错误')
            return
          }
          const regex2 = /^\d{18}$/
          if(card_type == '11' && !regex2.test(number)){
            this.$message.warning('证件格式错误')
            return
          }
          let query = {
            name: this.formData.name, //姓名
            number: this.formData.number,	// 身份证号
            card_type:this.formData.card_type
          }
          home.setRealName(this,query).then((res) => {
            if (res.data.code == 200) {
              this.dialogVisible = false;
              // localStorage.setItem("hasRealName", "hasRealName");
              this.$store.commit("SET_YD_REALNAME", res.data);
              this.$emit("triggerEvent");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.my-ruleForm{
  /deep/ .el-dialog__body {
    padding: 30px 57px 0px 0px;
    font-size: 14px
  }
  /deep/ .el-dialog__header{
    font-size: 16px
  }
  /deep/ .el-form-item__label{
    line-height: 38px
  }
   /deep/.el-form-item__content {
    margin-left: 100px !important;
  }
  /deep/.dialog-footer{
    button{
      width: 98px;
    }
  }
  .checkBox{
    padding-left: 50px
    color: #C0C4CC
    span{
      padding-left: 10px
    }
  }
}
</style>
